import React, { Component } from 'react';
import {Modal} from 'react-bootstrap';
import {connect} from 'react-redux';
import * as actionCreators from "../../../action/quote_order/leadcustomer.action.js";
import Pdf from '../../Pdf/Pdf';
import ReactToPrint from "react-to-print";
class ComponentToPrint extends Component {
  render() {
    return (
      <Pdf/>
    );
  }
}
class EditOrderQuote extends React.Component {


render() {
  let style;

  if (window.screen.availWidth < 500) {
    style = {'padding': '40px 20px'};
  }


    return (
       <div>


        <Modal centered show={this.props.editOrderQuoteAlertBox} dialogClassName="alert-modal react-modal " backdrop='static' keyboard={false} backdropClassName="sharing-model">         <button  className="close " onClick={(e) => this.props.CheckEditQuoteAlertBox(this.props.redirectvalue,'')}><span className="icon-close"></span></button>    
            <Modal.Body  style={style}>
              <h6 className="big-font">Alert</h6>
                <div className="row">
                  <div className="col-12">
                    <p className="mb-3 mt-3 roboto-medium">you want to edit with </p>
                  
                  </div>
                </div>

                 <div className="alert-footer"> 
                                    <button onClick={(e) => this.props.CheckEditQuoteAlertBox(this.props.redirectvalue,'edithere')} className='pushable pushable-with-left-right pushable-white'>          
                                                <span className="edge"></span>
                                                <div className="front w-sm justify-content-center">
                                                <div className="front-left">
                                                <span className="text ">Edit here</span>
                                                
                                                </div>
                                           
                                                </div>
                                           </button>

                                                <button onClick={(e) => this.props.CheckEditQuoteAlertBox(this.props.redirectvalue,'editwithcrm')} className='pushable pushable-with-left-right pushable-dark ml-3 '>          
                                                <span className="edge"></span>
                                                <div className="front  justify-content-center">
                                                <div className="front-left">
                                                <span className="text ">Edit with crm</span>
                                                
                                                </div>
                                           
                                                </div>
                                           </button>


                  </div>
                 
         
          </Modal.Body>       
         
        </Modal>


          
      </div>
    )
  }
}

const mapStoreToProps = (state) => {
  return state.leadcustomerReducer
}

export default connect(
  mapStoreToProps,
  actionCreators
)
(EditOrderQuote)
